// extracted by mini-css-extract-plugin
var _1 = "TextareaInlineField-moduleallInlineActions__AP2Ys";
var _2 = "TextareaInlineField-moduleoneInlineAction__L4_DX";
export { _1 as "allInlineActions", _2 as "oneInlineAction" }
